// Utils
import { normalizeOptions } from '../utils/options';
const get = (state, path) => {
    return path.reduce((obj, p) => {
        return obj === null || obj === void 0 ? void 0 : obj[p];
    }, state);
};
const set = (state, path, val) => {
    return ((path.slice(0, -1).reduce((obj, p) => {
        if (!/^(__proto__)$/.test(p))
            return (obj[p] = obj[p] || {});
        else
            return {};
    }, state)[path[path.length - 1]] = val),
        state);
};
const pick = (baseState, paths) => {
    return paths.reduce((substate, path) => {
        const pathArray = path.split('.');
        return set(substate, pathArray, get(baseState, pathArray));
    }, {});
};
const usePersistedState = (_options) => (_context) => {
    const { options: { persist }, store, } = _context;
    if (!persist) {
        return;
    }
    const { afterStoreHydration = null, beforeStoreHydration = null, key = store.$id, namespace = 'nvs', paths = null, serializer = {
        serialize: JSON.stringify,
        deserialize: JSON.parse,
    }, storage, } = normalizeOptions(persist, _options || {});
    const _storeName = `${namespace}_${key}`;
    const _init = async () => {
        store.$subscribe(async (_mutation, state) => {
            try {
                const toStore = Array.isArray(paths) ? pick(state, paths) : state;
                await storage.setItem(_storeName, serializer.serialize(toStore));
            }
            catch (_error) {
                // Void
            }
        }, { detached: true });
        if (beforeStoreHydration) {
            await beforeStoreHydration(_context);
        }
        const _storageData = await storage.getItem(_storeName);
        if (_storageData) {
            await store.$patch(serializer.deserialize(_storageData));
        }
        if (afterStoreHydration) {
            await afterStoreHydration(_context);
        }
    };
    _init();
};
export { usePersistedState };
//# sourceMappingURL=persist.js.map